import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Kurulum() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-red-600 transition-colors">Anasayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/hizmetler" className="hover:text-red-600 transition-colors">Hizmetler</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">Kurulum ve Kalibrasyon</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                3D Yazıcı <span className="text-red-600">Kurulum ve Kalibrasyon</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Yeni 3D yazıcılarınızın profesyonel kurulumu ve hassas kalibrasyonu için uzman desteği. Cihazınızın optimum performansla çalışmasını sağlıyoruz.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  Kurulum Randevusu Al
                </Link>
                <a 
                  href="https://wa.me/903123945635"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  WhatsApp ile İletişim
                </a>
              </div>
            </div>
            <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img 
                src="https://public.readdy.ai/ai/img_res/ac1daeb58b7857d802c42b74d68115dd.jpg"
                alt="3D Yazıcı Kurulum Hizmeti"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Installation Services */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Kurulum Hizmetlerimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profesyonel kurulum ile 3D yazıcınızın en iyi performansını elde edin
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-tools-line",
                title: "Fiziksel Kurulum",
                description: "Cihazın montajı, kablolama ve mekanik ayarları"
              },
              {
                icon: "ri-computer-line",
                title: "Yazılım Kurulumu",
                description: "Slicer yazılımı, sürücüler ve firmware kurulumu"
              },
              {
                icon: "ri-ruler-line",
                title: "Hassas Kalibrasyon",
                description: "Yatak seviyeleme, eksen kalibrasyonu ve flow ayarları"
              },
              {
                icon: "ri-temp-hot-line",
                title: "Isı Kalibrasyonu",
                description: "Hotend ve yatak sıcaklık optimizasyonu"
              },
              {
                icon: "ri-printer-line",
                title: "Test Baskısı",
                description: "Kalibrasyon baskısı ve kalite kontrolü"
              },
              {
                icon: "ri-graduation-cap-line",
                title: "Kullanım Eğitimi",
                description: "Temel kullanım ve bakım eğitimi"
              }
            ].map((service, index) => (
              <div 
                key={index}
                className={`bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Kurulum Sürecimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Adım adım profesyonel kurulum süreci
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: "01",
                title: "Ön Hazırlık",
                description: "Kurulum alanının hazırlanması ve gerekli malzemelerin kontrolü"
              },
              {
                step: "02",
                title: "Montaj",
                description: "Cihazın fiziksel montajı ve kablolama işlemleri"
              },
              {
                step: "03",
                title: "Kalibrasyon",
                description: "Hassas kalibrasyon ve optimizasyon ayarları"
              },
              {
                step: "04",
                title: "Test ve Eğitim",
                description: "Test baskısı ve kullanım eğitimi"
              }
            ].map((process, index) => (
              <div 
                key={index}
                className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${400 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  {process.step}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Installation Packages */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Kurulum Paketleri
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              İhtiyacınıza uygun kurulum paketi seçin
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: "Temel Kurulum",
                price: "₺599",
                features: [
                  "Fiziksel montaj",
                  "Temel kalibrasyon",
                  "Yazılım kurulumu",
                  "Test baskısı",
                  "Temel kullanım eğitimi"
                ],
                popular: false
              },
              {
                name: "Profesyonel Kurulum",
                price: "₺899",
                features: [
                  "Kapsamlı montaj",
                  "Hassas kalibrasyon",
                  "Yazılım optimizasyonu",
                  "Çoklu test baskısı",
                  "Detaylı kullanım eğitimi",
                  "1 ay teknik destek",
                  "Ayar dosyaları"
                ],
                popular: true
              },
              {
                name: "Premium Kurulum",
                price: "₺1299",
                features: [
                  "Tüm profesyonel hizmetler",
                  "İleri seviye optimizasyon",
                  "Özel profil oluşturma",
                  "Malzeme testleri",
                  "Kapsamlı eğitim",
                  "3 ay teknik destek",
                  "Ücretsiz ilk bakım"
                ],
                popular: false
              }
            ].map((package_, index) => (
              <div 
                key={index}
                className={`relative bg-white rounded-xl shadow-lg border-2 p-8 transition-all duration-300 hover:shadow-xl ${
                  package_.popular ? 'border-red-600 transform scale-105' : 'border-gray-200'
                } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${500 + index * 100}ms` }}
              >
                {package_.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                      En Popüler
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{package_.name}</h3>
                  <div className="text-4xl font-bold text-red-600 mb-2">{package_.price}</div>
                  <p className="text-gray-500">+ KDV</p>
                </div>

                <ul className="space-y-3 mb-8">
                  {package_.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-red-600 mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <Link 
                  to="/iletisim"
                  className={`w-full py-3 rounded-lg font-medium transition-colors cursor-pointer text-center block ${
                    package_.popular 
                      ? 'bg-red-600 hover:bg-red-700 text-white' 
                      : 'border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white'
                  }`}
                >
                  Paket Seç
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Calibration Details */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Hassas Kalibrasyon Hizmeti
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                3D yazıcınızın en iyi performansı için kritik olan kalibrasyon işlemlerini profesyonel ekipmanlarla gerçekleştiriyoruz.
              </p>
              
              <div className="space-y-4">
                {[
                  "Yatak seviyeleme (Manual ve otomatik)",
                  "Ekstruder kalibrasyon (E-steps)",
                  "Flow rate optimizasyonu",
                  "Sıcaklık kalibrasyonu",
                  "Retraction ayarları",
                  "Linear advance kalibrasyonu"
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <i className="ri-check-double-line text-red-600 text-xl"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className={`transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img 
                src="https://readdy.ai/api/search-image?query=Precision%203D%20printer%20calibration%20process%20with%20measurement%20tools%2C%20digital%20calipers%2C%20test%20prints%2C%20calibration%20cubes%2C%20professional%20technician%20hands%20adjusting%20printer%20settings%2C%20clean%20technical%20workspace%20with%20red%20and%20white%20corporate%20branding&width=600&height=500&seq=kalibrasyon-detail&orientation=landscape"
                alt="3D Yazıcı Kalibrasyon"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Sık Sorulan Sorular
            </h2>
            <p className="text-xl text-gray-600">
              3D yazıcı kurulumu hakkında merak edilenler
            </p>
          </div>

          <div className="space-y-6">
            {[
              {
                question: "Kurulum ne kadar sürer?",
                answer: "Cihazın karmaşıklığına göre değişmekle birlikte, ortalama kurulum süresi 2-4 saattir. Premium paketlerde daha detaylı kalibrasyon nedeniyle süre uzayabilir."
              },
              {
                question: "Hangi markaları kuruyorsunuz?",
                answer: "Tüm popüler 3D yazıcı markalarında kurulum hizmeti veriyoruz. Creality, Prusa, Ultimaker, Anycubic ve diğer markalar dahil."
              },
              {
                question: "Kurulum sonrası destek var mı?",
                answer: "Evet, seçtiğiniz pakete göre 1-3 ay arası teknik destek veriyoruz. Bu süre içinde karşılaştığınız sorunlarda ücretsiz destek alabilirsiniz."
              },
              {
                question: "Evde kurulum yapıyor musunuz?",
                answer: "Evet, Ankara genelinde evde kurulum hizmeti veriyoruz. Ek bir servis ücreti karşılığında cihazınızı kullanacağınız ortamda kuruyoruz."
              },
              {
                question: "Kurulum öncesi ne hazırlamalıyım?",
                answer: "Temiz ve düz bir yüzey, elektrik bağlantısı ve internet erişimi yeterlidir. Gerekli tüm araç gereçleri ekibimiz getirir."
              }
            ].map((faq, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg p-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${800 + index * 100}ms` }}
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Yeni 3D Yazıcınızı Profesyonelce Kuralım
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Uzman ekibimizle cihazınızın optimum performansla çalışmasını sağlayın. Hemen kurulum randevusu alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:03123945635"
              className="bg-white text-red-600 hover:bg-red-50 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Hemen Ara
            </a>
            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-8 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
                <li><a href="#" className="hover:text-white transition-colors">Referanslar</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0541 456 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
